import { Alert, Badge, Group, ScrollArea, Stack, Text } from '@mantine/core'
import { AppModal, InlineLoader } from '@/components/ui'
import {
  TicketTimelineAnalysisPanel,
  TicketTimelineMetricsPanel,
  TicketTimelineView,
  type TimelineQuickRangeKey,
} from '@/components/tickets/TicketTimelinePanels'
import type { TicketTimelineItem, TicketTimelineResponse } from '@/types/api'

type TicketTimelineModalProps = {
  opened: boolean
  loading: boolean
  error: string | null
  timeline: TicketTimelineResponse | null
  fromId: string | null
  toId: string | null
  selectedIds: string[]
  selectedKind: TimelineQuickRangeKey | null
  onClose: () => void
  onSelectItems: (ids: string[], kind: TimelineQuickRangeKey) => void
  onResetRange: () => void
  onPick: (item: TicketTimelineItem) => void
}

export function TicketTimelineModal({
  opened,
  loading,
  error,
  timeline,
  fromId,
  toId,
  selectedIds,
  selectedKind,
  onClose,
  onSelectItems,
  onResetRange,
  onPick,
}: TicketTimelineModalProps) {
  return (
    <AppModal opened={opened} onClose={onClose} title="Таймлайн обращения" size="xl">
      <Stack gap="sm">
        {timeline ? (
          <Group gap={8} wrap="wrap">
            <Badge variant="light" color="blue">
              #{timeline.ticket_number}
            </Badge>
            {timeline.project_name ? (
              <Badge variant="light" color="gray">
                {timeline.project_name}
              </Badge>
            ) : null}
            <Text size="xs" c="dimmed">
              {timeline.items.length} событий
            </Text>
          </Group>
        ) : null}
        {error ? (
          <Alert color="red">{error}</Alert>
        ) : loading && !timeline ? (
          <InlineLoader label="Загрузка таймлайна" />
        ) : (
          <>
            <TicketTimelineMetricsPanel metrics={timeline?.metrics} />
            <TicketTimelineAnalysisPanel
              items={timeline?.items ?? []}
              metrics={timeline?.metrics}
              fromId={fromId}
              toId={toId}
              selectedIds={selectedIds}
              selectedKind={selectedKind}
              onSelectItems={onSelectItems}
              onResetRange={onResetRange}
            />
            <ScrollArea.Autosize mah="min(62vh, 660px)" type="auto" offsetScrollbars="y" scrollbarSize={8}>
              <TicketTimelineView
                items={timeline?.items ?? []}
                fromId={fromId}
                toId={toId}
                selectedIds={selectedIds}
                onPick={onPick}
              />
            </ScrollArea.Autosize>
          </>
        )}
      </Stack>
    </AppModal>
  )
}
